import { render, staticRenderFns } from "./single.vue?vue&type=template&id=21ec44b6&scoped=true&"
import script from "./single.vue?vue&type=script&lang=js&"
export * from "./single.vue?vue&type=script&lang=js&"
import style0 from "./single.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./single.vue?vue&type=style&index=1&id=21ec44b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec44b6",
  null
  
)

export default component.exports